import { Pipe, PipeTransform } from "@angular/core";

import { MedOptionType } from "../../public-api";
import { STRING } from "../constants/string";

@Pipe({
  name: "singleOption",
})
export class SingleOptionPipe implements PipeTransform {
  transform(value: string, disabled = false): MedOptionType<string>[] {
    return [{ label: STRING.EMPTY, value, disabled }];
  }
}
